"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRotations = void 0;
const react_1 = require("react");
const generation_1 = require("@player-core/generation");
const store_1 = require("@player-core/kernel/lib/store");
const MS_IN_DAY = 24 * 60 * 60 * 1000;
const useRotations = (settings, mediafiles = {}, sleepSettings) => {
    const [generator, setGenerator] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setGenerator(new generation_1.GenerateSchedule());
    }, []);
    const mapToRotationData = (0, react_1.useCallback)((rotations, skipped) => {
        return rotations.map((rotation) => {
            var _a;
            const mediafile = mediafiles[rotation.mediafileId];
            const meta = mediafile.meta;
            return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ rotationId: 0, streamId: rotation.adcompanyId ? undefined : settings === null || settings === void 0 ? void 0 : settings.stream.id, adcampaign: rotation.adcompanyId ? { id: rotation.adcompanyId } : undefined, adcampaignId: rotation.adcompanyId }, meta), { skipped, endTime: (_a = rotation.endTime) === null || _a === void 0 ? void 0 : _a.toISOString() }), rotation), (mediafile && {
                mediafile: Object.assign(Object.assign({}, rotation.mediafile), mediafile),
                mediafileId: mediafile === null || mediafile === void 0 ? void 0 : mediafile.id,
                type: mediafile === null || mediafile === void 0 ? void 0 : mediafile.type,
            })), { playtime: Date.parse(rotation.playtime.toISOString()) });
        });
    }, [settings, mediafiles]);
    const mapToRotationsList = (0, react_1.useCallback)((rotations, skippedPromos) => {
        const playlistItems = mapToRotationData(rotations, false);
        const skippedPromoRotations = Object.values(skippedPromos.byId).flat();
        const skippedPromoItems = mapToRotationData(skippedPromoRotations, true);
        return [...playlistItems, ...skippedPromoItems]
            .sort((a, b) => a.playtime - b.playtime)
            .map((item, inIndex) => {
            return Object.assign(Object.assign({}, item), { rotationId: inIndex + 1 });
        });
    }, [mapToRotationData]);
    const generateSchedule = (0, react_1.useCallback)((start, end) => __awaiter(void 0, void 0, void 0, function* () {
        if (!generator || !settings) {
            return null;
        }
        const result = yield generator.generate(settings, start, end);
        if (!result)
            return null;
        const { rotations, skippedPromos } = result;
        const mappedRotationsList = mapToRotationsList(rotations, skippedPromos);
        return {
            rotations,
            mappedRotationsList,
            skippedPromos,
            intervals: [{ start, end }],
        };
    }), [generator, settings, mapToRotationsList]);
    const mergeResult = (firstResult, secondResult) => {
        if (!firstResult || !secondResult) {
            return firstResult || secondResult;
        }
        const { rotations: firstRotations, skippedPromos: firstSkippedPromo, mappedRotationsList: firstMappedRotationsList, intervals: firstIntervals, } = firstResult;
        const { rotations: secondRotations, skippedPromos: secondSkippedPromo, mappedRotationsList: secondMappedRotationsList, intervals: secondIntervals, } = secondResult;
        const resultSkippedPromo = {
            total: firstSkippedPromo.total + secondSkippedPromo.total,
            byId: Object.assign({}, firstSkippedPromo.byId),
        };
        Object.keys(secondSkippedPromo.byId).forEach((key) => {
            if (!firstSkippedPromo.byId[key]) {
                resultSkippedPromo.byId[key] = secondSkippedPromo.byId[key];
            }
            else {
                resultSkippedPromo.byId[key] = [
                    ...firstSkippedPromo.byId[key],
                    ...secondSkippedPromo.byId[key],
                ];
            }
        });
        return {
            mappedRotationsList: [...firstMappedRotationsList, ...secondMappedRotationsList],
            rotations: [...firstRotations, ...secondRotations],
            skippedPromos: resultSkippedPromo,
            intervals: [...(firstIntervals || []), ...secondIntervals],
        };
    };
    const generateScheduleWithSleep = (0, react_1.useCallback)((start, end) => __awaiter(void 0, void 0, void 0, function* () {
        let currentStart = start;
        let currentEnd = end;
        if ((sleepSettings === null || sleepSettings === void 0 ? void 0 : sleepSettings.options) && (sleepSettings === null || sleepSettings === void 0 ? void 0 : sleepSettings.sleepMode)) {
            const prevDay = new Date(start.valueOf() - MS_IN_DAY);
            const currentIntervals = store_1.SleepSettingsService.getWorkingIntervalByDate(currentStart, sleepSettings === null || sleepSettings === void 0 ? void 0 : sleepSettings.options, sleepSettings === null || sleepSettings === void 0 ? void 0 : sleepSettings.timezone);
            const prevDayIntervals = store_1.SleepSettingsService.getWorkingIntervalByDate(prevDay, sleepSettings === null || sleepSettings === void 0 ? void 0 : sleepSettings.options, sleepSettings === null || sleepSettings === void 0 ? void 0 : sleepSettings.timezone);
            const { start: startFromPrevDay, end: endFromPrevDay } = prevDayIntervals;
            const { start: startFromSettings, end: endFromSettings } = currentIntervals;
            currentStart =
                startFromSettings && currentStart.valueOf() < startFromSettings
                    ? new Date(startFromSettings)
                    : currentStart;
            currentEnd =
                endFromSettings && (currentEnd === null || currentEnd === void 0 ? void 0 : currentEnd.valueOf()) > endFromSettings
                    ? new Date(endFromSettings)
                    : currentEnd;
            if (endFromPrevDay.valueOf() > start.valueOf()) {
                const firstPart = yield generateSchedule(start, new Date(endFromPrevDay));
                const secondPart = yield generateSchedule(currentStart, currentEnd);
                return mergeResult(firstPart, secondPart);
            }
        }
        return generateSchedule(currentStart, currentEnd);
    }), [generateSchedule, sleepSettings]);
    return { generateSchedule, generateScheduleWithSleep, mapToRotationsList, state: generator === null || generator === void 0 ? void 0 : generator.state };
};
exports.useRotations = useRotations;
//# sourceMappingURL=useRotations.js.map